import { StateCreator } from "zustand";

export interface CourseManagementState {
  showFilter: boolean;
  courseName: string;
  reloadFeedback: boolean;
  reloadDiscussion: boolean;
  discussionMode: string;
  setShowFilter: (data: boolean) => void;
  setCourseName: (data: string) => void;
  setReloadFeedback: (data: boolean) => void;
  setReloadDiscussion: (data: boolean) => void;
  setDiscussionMode: (data: string) => void;
}

export const courseManagementSlice: StateCreator<CourseManagementState> = (
  set
) => ({
  showFilter: false,
  courseName: "",
  reloadFeedback: false,
  reloadDiscussion: false,
  discussionMode: "",
  setShowFilter: (value: boolean) => {
    set({ showFilter: value });
  },
  setCourseName: (value: string) => {
    set({ courseName: value });
  },
  setReloadFeedback: (value: boolean) => {
    set({ reloadFeedback: value });
  },
  setReloadDiscussion: (value: boolean) => {
    set({ reloadDiscussion: value });
  },
  setDiscussionMode: (value: string) => {
    set({ discussionMode: value });
  },
});
